<template>
  <div>
    <div>
      <p class="text-heading-xs">
        Välj arbetsgivare ({{ foretagList.length }})
      </p>
    </div>
    <hr />
    <div>
      <avtalat-input
        v-model:value="filterString"
        icon="sammanstallning"
        placeholder="Filtrera arbetsgivare"
      />
    </div>
    <div>
      <avtalat-table small :headings="headings">
        <avtalat-table-row v-for="foretag in filterResults()" :key="foretag.id">
          <avtalat-table-cell>{{ foretag.idNumber }}</avtalat-table-cell>
          <avtalat-table-cell>{{ foretag.name }}</avtalat-table-cell>
          <avtalat-table-cell>
            <avtalat-icon
              class="foretag-list__row-button"
              id="pil-hoger-1"
              v-on:click="
                navigateToArbetsgivareView(foretag.idNumber, foretag.ombudId)
              "
              color="teal-400"
              bold
            />
          </avtalat-table-cell>
        </avtalat-table-row>
      </avtalat-table>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

import type { SearchResponse } from "@/composables/KundserviceAppApiClient";
import { useNavigation } from "@/composables/useNavigation";

const navigation = useNavigation();

const headings = [
  {
    content: '<span class="type-heading-xs">Org.nr.</span>',
    width: 40,
  },
  {
    content: '<span class="type-heading-xs">Namn</span>',
    width: 40,
  },
];

const filterString = ref("");

function filterResults() {
  const regex = new RegExp(filterString.value, "i");
  return props.foretagList.filter((item) => regex.test(item.name || ""));
}

const props = defineProps<{
  foretagList: SearchResponse[];
}>();

function navigateToArbetsgivareView(
  organisationsnummer: string | undefined | null,
  arbetsgivarrepresentantId: string | undefined | null,
) {
  if (!organisationsnummer) {
    return;
  }
  navigation.openArbetsgivare(organisationsnummer, arbetsgivarrepresentantId);
}
</script>
